import React from 'react';
import {Icon, TooltipHost} from "office-ui-fabric-react";

interface IProps {
  value: boolean;
  fieldTitle: string;
}

const BooleanText = ({ value, fieldTitle }: IProps) => {
  return (
    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
      <span>
        {
          value ? 'Заданы' : 'Не заданы'
        }
      </span>
      {
        !value &&
          <TooltipHost content={`Необходимо заполнить раздел "${fieldTitle} BLE-меток" для данного типа. Обратитесь к Оператору BLE-меток `} id={'a'} calloutProps={{ gapSpace: 0 }}>
            <Icon
                iconName="Info"
                styles={{
                  root: {
                    color: 'red',
                    fontSize: '18px',
                    marginLeft: '5px',
                    cursor: 'pointer',
                  }
                }}
            />
          </TooltipHost>
      }
    </div>
  );
};

export default BooleanText;